module.exports = __webpack_public_path__ + "78cadad55a1f196e7957bdc31053675e.png";